// document.addEventListener("DOMContentLoaded", function () {
//     const cartButtons = document.querySelectorAll("a[href='/cart'], a[href='/checkout']");

//     cartButtons.forEach(button => {
//         button.addEventListener("click", function (event) {
//             event.preventDefault(); // Stop the default link behavior immediately
//             console.log("Cart or Checkout button clicked, checking cart...");

//             fetch("/cart.js")
//                 .then(response => response.json())
//                 .then(cart => {
//                     console.log("Cart data:", cart);

//                     if (cart.item_count === 0) {
//                         alert("Your cart is empty! Please add items before proceeding.");
//                         console.log("Cart is empty. Staying on the same page.");
//                     } else {
//                         console.log("Cart has items. Redirecting...");
//                         window.location.href = button.href; // Manually redirect only if cart has items
//                     }
//                 })
//                 .catch(error => {
//                     console.error("Error fetching cart data:", error);
//                 });
//         });
//     });
// });




document.addEventListener("DOMContentLoaded", function () {
  const menuItem = document.getElementById("HeaderMenu-power-tool-university");

  if (menuItem) {
    menuItem.style.display = "flex";
    menuItem.style.flexDirection = "column";
    const newText = document.createElement("div");
    newText.textContent = "How-To Videos";
    newText.style.fontSize = "0.875rem"; // optional: style as needed
    newText.style.color = "inherit"; // optional: match existing text
    newText.style.marginTop = "4px"; // spacing between lines

    menuItem.appendChild(newText);
  }
});
